import { getStatusById } from '../getStatusById';
import { type TOrdersResponse } from '../../../redux/types/OrdersTypes';
import formatNumber from '../formatNumber';
import { formatExpectedForeign, formatReceivedForeign } from '../foreignAmount';

export interface OrderModel {
  id: string;
  status: string;
  statusId: string;
  isSelectorStatusActive: boolean;
  card_number: string;
  bank: string;
  expected_income: string;
  real_income: string;
  temp_income?: string;
  foreign_expected?: string;
  foreign_received?: string;
  date: string;
  fio?: string;
  time_left?: number;
  has_files?: boolean;
  integration_order: boolean,
  comments: Record<number, string>;
}

const mapOrders = (orders: TOrdersResponse[] | undefined): OrderModel[] => {
  return (
    orders?.map((item: TOrdersResponse) => {
      const currencyCode = item.currency_code_to || 'RUB';
      return {
        id: item.id,
        status: getStatusById(item.status),
        statusId: item.status,
        isSelectorStatusActive: false,
        card_number: item.requisite.account_number,
        fio: item.requisite.fio,
        bank: item.requisite.bank.name,
        expected_income: `${formatNumber(item.expected_income, 2)} ${currencyCode}`,
        real_income: `${formatNumber(item.real_income, 2)} ${currencyCode}`,
        temp_income: `${formatNumber(item.temp_income || 0, 2)} ${currencyCode}`,
        foreign_expected: formatExpectedForeign(item),
        foreign_received: formatReceivedForeign(item),
        date: item.create_dt,
        time_left: item.time_left,
        has_files: item.has_files,
        integration_order: item.integration_order,
        comments: item.comments
      };
    }) ?? []
  );
};

export default mapOrders;
